exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".psychological-teachers-use[data-v-30ea22be] {\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 10px;\n}\n.psychological-teachers-use .tip[data-v-30ea22be] {\n  padding: 15px;\n  border-radius: 10px;\n  line-height: 1.8;\n  background-color: #fefce8;\n}\n", ""]);

// exports
